import { render, staticRenderFns } from "./TriangleTriangle.vue?vue&type=template&id=8b9c332e&"
import script from "./TriangleTriangle.vue?vue&type=script&lang=js&"
export * from "./TriangleTriangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports